.root {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 14px 14px;
}

// Pen `eHV99`: unified search/browse field with a magnifying glass and a
// "⌘K" shortcut hint. Replaces the earlier AI Recommended / Browse toggle.
.search {
  display: flex;
  align-items: center;
  gap: 7px;
  height: 34px;
  padding: 0 10px;
  background: var(--rec-color-background);
  border: 1px solid var(--rec-color-border-strong);
  border-radius: 8px;
  color: #94a3b8;
}

.search-input {
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  font: inherit;
  font-size: 11px;
  font-weight: 500;
  color: var(--rec-color-btn-dark);
  outline: none;

  &::placeholder {
    color: #94a3b8;
    font-weight: 500;
  }
}

.shortcut {
  flex: none;
  font-size: 9px;
  font-weight: 700;
  color: var(--rec-color-border-strong);
  letter-spacing: 0.2px;
}

.meta {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 0;
}

.meta-label {
  flex: 1;
  min-width: 0;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.6px;
  color: #94a3b8;
}

.meta-count {
  flex: none;
  font-size: 10px;
  font-weight: 600;
  color: #8b5cf6;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

// Pen `xkL4p`: bottom "Browse the full {city} {category} catalog →" CTA.
.browse-cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 38px;
  background: var(--rec-color-header-bg);
  border: 1px solid var(--rec-color-border-strong);
  border-radius: 8px;
  cursor: pointer;
  font: inherit;
}

.browse-cta-icon {
  color: var(--rec-color-muted-fg);
}

.browse-cta-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--rec-color-muted-fg);
}

.browse-cta-arrow {
  color: var(--rec-color-muted-fg);
}
